import { twMergeConfig } from '../utils';

import { forwardRef, type ComponentPropsWithoutRef, type ForwardRefRenderFunction } from 'react';
import { tv } from 'tailwind-variants';

type As = Extract<React.ElementType, 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span'>;

export type FontSize = 'ant' | 'frog' | 'rat' | 'rabbit' | 'cat' | 'dog' | 'leopard' | 'wolf' | 'deer' | 'bear';

export type FontWeight =
  // 400
  | 'regular'
  // 700
  | 'bold';

export interface TypographyProps extends ComponentPropsWithoutRef<'span'> {
  as?: As;
  size?: FontSize;
  weight?: FontWeight;
}

export const textVariant = tv(
  {
    base: 'break-words font-sans text-sem-l-text-high',
    variants: {
      size: {
        ant: 'text-ant leading-ant',
        frog: 'text-frog leading-frog',
        rat: 'text-rat leading-rat',
        rabbit: 'text-rabbit leading-rabbit',
        cat: 'text-cat leading-cat',
        dog: 'text-dog leading-dog',
        leopard: 'text-leopard leading-leopard',
        wolf: 'text-wolf leading-wolf',
        deer: 'text-deer leading-deer',
        bear: 'text-bear leading-bear',
      },
      weight: {
        regular: 'font-normal',
        bold: 'font-bold',
      },
    },
  },
  {
    twMergeConfig: twMergeConfig,
  }
);

const TypographyWithRef: ForwardRefRenderFunction<HTMLDivElement, TypographyProps> = (
  { children, size = 'cat', weight = 'regular', as: Tag = 'span', className, onBeforeInput, ...spanRest },
  ref
) => {
  const style = textVariant({ size, weight, className });
  const rest = { ...spanRest, ref };
  return (
    <Tag className={style} {...rest}>
      {children}
    </Tag>
  );
};

export const Typography = forwardRef(TypographyWithRef);
